var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.mTypes, function ([key, item]) {
        return _c("div", { key: "legend-" + item.mtype }, [
          _c("img", { attrs: { src: item.markerIcon } }),
          _c("span", [_vm._v(_vm._s(item.label))]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }